<template>
  <div class="wl-certity-query-wrapper">
    <div class="pc-certity-query-main">
      <div
        class="head-banner-con"
        :style="{ backgroundImage: 'url(' + bannerImg + ')' }"
      >
        <div class="search-cerfity-content clearfix">
          <div class="search-form-con">
            <h1 class="cerfity-title-con">物流相关证书查询系统</h1>
            <div class="clearfix search-btns">
              <div
                class="fl search-query-btn"
                :class="{ avtiveBtn: activeIndex == 1 }"
                @click="queryBtn(1)"
              >
                物流从业人员证书查询
              </div>
              <div
                class="fr search-query-btn"
                :class="{ avtiveBtn: activeIndex == 2 }"
                @click="queryBtn(2)"
              >
                物流管理职业技能等级证书查询
              </div>
            </div>
            <div class="clearfix search1-btns">
              <div
                class="fl search1-query-btn"
                :class="{ avtiveBtn1: activeTypeIndex == 1 }"
                @click="queryTypeBtn(1)"
              >
                姓名+身份证号查询
              </div>
              <div
                class="fr search1-query-btn"
                :class="{ avtiveBtn1: activeTypeIndex == 2 }"
                @click="queryTypeBtn(2)"
              >
                姓名+证书编号查询
              </div>
            </div>
            <el-form
              :model="ruleForm"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item
                label="证书类型"
                prop="type"
                v-if="activeIndex == 2"
              >
                <el-select v-model="ruleForm.type" placeholder="请选择证书类型">
                  <el-option
                    v-for="item in typeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="姓名" prop="name">
                <el-input v-model="ruleForm.name"></el-input>
              </el-form-item>
              <el-form-item
                label="身份证号"
                prop="IDNum"
                v-if="activeTypeIndex == 1"
              >
                <el-input v-model="ruleForm.IDNum"></el-input>
              </el-form-item>
              <el-form-item
                label="证书编号"
                prop="cerfityNum"
                v-if="activeTypeIndex == 2"
              >
                <el-input v-model="ruleForm.cerfityNum"></el-input>
              </el-form-item>
            </el-form>
            <div class="search-btn-con">
              <el-button type="primary" @click="cerfityQuery">查询</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="guide-search-main">
        <div class="grade-search-con clearfix">
          <div class="fl query-guide-con">
            <div class="clearfix">
              <div class="icon-head-con head-con-1 fl">
                <i class="wl-icon-nanbei"></i>
              </div>
              <span class="sp-label-title fl">查询指南</span>
            </div>
            <p class="p-grade-title-1">任意输入以下组合内容即可查询：</p>
            <!-- <ul class="guide-ul-con">
              <li>1.身份证号+证书编号</li>
              <li>2.身份证号+姓名</li>
              <li>3.证书编号+姓名</li>
              <li>4.姓名+身份证号+证书编号</li>
            </ul> -->
            <ul class="guide-ul-con">
              <li>1.姓名+身份证号</li>
              <li>2.姓名+证书编号</li>
            </ul>
          </div>
          <div class="fr care-way-con">
            <div class="clearfix">
              <div class="icon-head-con head-con-2 fl">
                <i class="wl-icon-exclamation"></i>
              </div>
              <span class="sp-label-title fl">注意事项</span>
            </div>
            <p class="p-care-con">
              北京中物联物流采购培训中心全国联网查询系统仅限于查询北京中物联物流采购培训中心颁发的物流职业技能等级证书；
              全国各级考核中心数据上传和审核需要一定的时间周期，如急需核实证书真伪，可致电:010-83775917。
            </p>
          </div>
        </div>
      </div>
      <!-- 学生成绩弹框 -->
      <el-dialog
        title="成绩信息"
        :visible.sync="gradeVisible"
        width="650px"
        class="grade-dialog-main"
        :close-on-click-modal="false"
      >
        <div>
          <ul>
            <li>
              <span>1.姓名：</span>
              <span>{{ stuGradeInfo.name }}</span>
            </li>
            <li>
              <span>2.理论考试成绩：</span>
              <span>{{ stuGradeInfo.themeGrade }}</span>
            </li>
            <li>
              <span>3.实操线上考试成绩：</span>
              <span>{{ stuGradeInfo.operateOnline }}</span>
            </li>
            <li>
              <span>4.实操线下考试成绩：</span>
              <span>{{ stuGradeInfo.operateOutline }}</span>
            </li>
          </ul>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="gradeVisible = false"
            >关闭</el-button
          >
        </span>
      </el-dialog>
      <!-- 证书查询弹框完成 -->
      <el-dialog
        title="成绩信息"
        :visible.sync="cerfityVisible"
        width="650px"
        class="grade-dialog-main"
        :close-on-click-modal="false"
      >
        <div class="cerfity-show-main">
          <img :src="modelCerfity" alt />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="cerfityVisible = false"
            >关闭</el-button
          >
        </span>
      </el-dialog>
    </div>
    <div class="ph-certify-query-main">
      <div class="form-content">
        <h3 class="h3-title-val">证书查询</h3>
        <div class="searchModel">
          <span class="wl-icon-dian1"></span>物流从业人员证书查询
        </div>
        <div class="clearfix search1-btns">
          <div
            class="fl search1-query-btn"
            :class="{ avtiveBtn1: activeTypeIndex == 1 }"
            @click="queryTypeBtn(1)"
          >
            姓名+身份证号查询
          </div>
          <div
            class="fr search1-query-btn"
            :class="{ avtiveBtn1: activeTypeIndex == 2 }"
            @click="queryTypeBtn(2)"
          >
            姓名+证书编号查询
          </div>
        </div>
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          label-position="left"
          size="small"
          label-width="70px"
        >
          <el-form-item label="姓名" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item
            label="身份证号"
            prop="name"
            v-if="activeTypeIndex == 1"
          >
            <el-input v-model="ruleForm.IDNum"></el-input>
          </el-form-item>
          <el-form-item
            label="证书编号"
            prop="name"
            v-if="activeTypeIndex == 2"
          >
            <el-input v-model="ruleForm.cerfityNum"></el-input>
          </el-form-item>
        </el-form>
        <div class="search-btn-con">
          <el-button
            type="primary"
            size="small"
            @click="cerfityQuery"
            style="font-size: 16px; width: 60%"
            >查询</el-button
          >
        </div>
        <div class="searchModel">
                <span class="wl-icon-dian1"></span>物流管理职业技能等级证书查询
        </div>
        <div class="clearfix search1-btns">
          <div
            class="fl search1-query-btn"
            :class="{ avtiveBtn1: activeTypeIndex2 == 1 }"
            @click="queryTypeBtn2(1)"
          >
            姓名+身份证号查询
          </div>
          <div
            class="fr search1-query-btn"
            :class="{ avtiveBtn1: activeTypeIndex2 == 2 }"
            @click="queryTypeBtn2(2)"
          >
            姓名+证书编号查询
          </div>
        </div>
        <el-form
          :model="ruleForm1"
          ref="ruleForm"
          label-position="left"
          size="small"
          label-width="70px"
        >
          <el-form-item label="证书类型" prop="type">
            <el-select v-model="ruleForm1.type" placeholder="请选择证书类型">
              <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input v-model="ruleForm1.name"></el-input>
          </el-form-item>
          <el-form-item
            label="身份证号"
            prop="name"
            v-if="activeTypeIndex2 == 1"
          >
            <el-input v-model="ruleForm1.IDNum"></el-input>
          </el-form-item>
          <el-form-item
            label="证书编号"
            prop="name"
            v-if="activeTypeIndex2 == 2"
          >
            <el-input v-model="ruleForm1.cerfityNum"></el-input>
          </el-form-item>
        </el-form>
        <div class="search-btn-con">
          <el-button
            type="primary"
            size="small"
            @click="cerfityQuery1"
            style="font-size: 16px; width: 60%"
            >查询</el-button
          >
        </div>
      </div>
      <div class="form-content">
        <p class="p-query-title"><i class="el-icon-question"></i> 查询指南</p>
        <p>任意输入以下组合内容即可查询：</p>
        <!-- <ul class="guide-ul-con">
          <li>1.身份证号+证书编号</li>
          <li>2.身份证号+姓名</li>
          <li>3.证书编号+姓名</li>
          <li>4.姓名+身份证号+证书编号</li>
        </ul> -->
        <ul class="guide-ul-con">
          <li>1.姓名+身份证号</li>
          <li>2.姓名+证书编号</li>
        </ul>
      </div>
      <div class="form-content">
        <p class="p-query-title"><i class="el-icon-info"></i> 注意事项</p>
        <p class="p-care-li">
          北京中物联物流采购培训中心全国联网查询系统仅限于查询北京中物联物流采购培训中心颁发的物流职业技能等级证书；
          全国各级考核中心数据上传和审核需要一定的时间周期，如急需核实证书真伪，可致电:010-83775917。
        </p>
      </div>
      <div>
        <img :src="certifyUrl" alt="" />
      </div>
    </div>

    <el-dialog
      title="证书查询"
      :visible.sync="dialogVisible"
      width="1000px"
      :before-close="handleClose"
    >
      <div align="center" class="father" v-if="dialogVisible">
        <!--  :style="{backgroundImage: 'url(' + certificate + ')'}" -->
        <canvas
          class="canvas"
          width="900px"
          height="650px"
          id="canvas"
        ></canvas>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >关 闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      stuInfo: {},
      certificate: require("assets/images/certificate.png"),
      dialogVisible: false,
      // 登录
      bannerImg: require("assets/images/certify-banner-img.png"),
      modelCerfity: require("assets/images/cerfity-model.png"),
      ruleForm: {
        type: "",
        name: "",
        IDNum: "",
        cerfityNum: "",
      },
      ruleForm1: {
        type: "",
        name: "",
        IDNum: "",
        cerfityNum: "",
      },
      // ruleForm: {
      //   name: "吴义祥",
      //   IDNum: "340826199812121234",
      //   cerfityNum: ""
      // },
      gradeVisible: false,
      cerfityVisible: false,
      stuGradeInfo: {
        name: "",
        themeGrade: 0,
        operateOnline: 0,
        operateOutline: 0,
      },
      activeIndex: 1,
      activeTypeIndex: 1,
      activeTypeIndex2: 1,
      certifyUrl: "",
      showImg: false,
      typeList: [
        {
          value: "物流管理职业技能等级证书",
          label: "物流管理职业技能等级证书",
        },
        {
          value: "物流管理职业技能等级证书师资证书",
          label: "物流管理职业技能等级证书师资证书",
        },
        {
          value: "物流管理职业技能等级证书考评员证书",
          label: "物流管理职业技能等级证书考评员证书",
        },
      ],
      activeName: "姓名+身份证号查询",
    };
  },
  mounted() {
    // this.getCanvas();
  },
  computed: {
    association: function () {
      return this.$store.state.association;
    },
    userInfo() {
      return this.$store.state.auth;
    },
  },
  created() {
  },
  methods: {
    getCanvas() {
      var canvas = document.getElementById("canvas");
      var ctx = canvas.getContext("2d");
      // 绘制背景图
      var image1 = new Image();
      image1.src = this.certificate;
      var promise1 = new Promise((resolve, reject) => {
        image1.onload = function () {
          ctx.drawImage(image1, 0, 0, 900, 650);
          resolve("ok");
        };
      });
      promise1
        .then((res) => {
          if (res == "ok") {
            // 学生姓名
            ctx.font = "14px Arial";
            ctx.fillStyle = "#1c1417";
            ctx.fillText(`${this.stuInfo.studentName}`, 730, 340);
            ctx.stroke();
            // 学生姓名（拼音）
            ctx.font = "14px Arial";
            ctx.fillStyle = "#1c1417";
            ctx.fillText(`${this.stuInfo.studentNamePinyin}`, 710, 370);
            ctx.stroke();
            // 参加物流考试时间
            ctx.font = "16px Source Han Sans CN";
            ctx.fillStyle = "#1c1417";
            ctx.fillText(`${this.stuInfo.examTime}`, 145, 198);
            // 级别（初级 中级 高级）
            ctx.font = "16px Source Han Sans CN";
            ctx.fillStyle = "#1c1417";
            ctx.fillText(`${this.stuInfo.examinationGrade}`, 359, 228);
            // 参加物流考试的时间（英文）
            ctx.font = "italic 12px Arial";
            ctx.fillStyle = "#1c1417";
            ctx.fillText(`in ${this.stuInfo.examYMEnglish}`, 555, 285);
            // 级别（初级 中级 高级）（英文）
            ctx.font = "italic 12px Arial";
            ctx.fillStyle = "#1c1417";
            ctx.fillText(`${this.stuInfo.examinationGradeEnglish}`, 242, 313);
            // 身份证
            ctx.font = "16px Source Han Sans CN";
            ctx.fillStyle = "#1c1417";
            ctx.fillText(`${this.stuInfo.idCard}`, 230, 380);
            // 证书编号
            ctx.font = "16px Source Han Sans CN";
            ctx.fillStyle = "#1c1417";
            ctx.fillText(`${this.stuInfo.certificateNum}`, 230, 420);
            // 发放证书时间
            ctx.font = "16px Source Han Sans CN";
            ctx.fillStyle = "#1c1417";
            ctx.fillText(`${this.stuInfo.dateofIssue}`, 230, 505);
            var image = new Image();
            image.setAttribute("crossOrigin", "Anonymous");
            image.src = this.stuInfo.studentUrl;
            image.onload = () => {
              ctx.drawImage(image, 698, 190, 100, 130);
              this.certifyUrl = canvas.toDataURL("image/jpeg");
            };
          }
        })
        .catch((err) => {});
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 成绩查询
    cerfityQuery() {
      var that = this;
      this.$http
        .post("/api/XOrg/ResultsManager/getStuResultInfo", {
          activeIndex: this.activeIndex,
          activeTypeIndex: this.activeTypeIndex,
          type: this.ruleForm.type,
          name: this.ruleForm.name,
          IDNum: this.ruleForm.IDNum,
          cerfityNum: this.ruleForm.cerfityNum,
        })
        .then((rst) => {
          if (rst.code > 0) {
            that.stuInfo = rst.info;
            that.dialogVisible = true;
            that.$nextTick(() => {
              that.getCanvas();
            });
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    queryBtn(index) {
      this.activeIndex = index;
    },
    queryTypeBtn(index) {
      this.activeTypeIndex = index;
      if (index == 1) {
        this.ruleForm.cerfityNum = "";
      } else if (index == 2) {
        this.ruleForm.name = "";
        this.ruleForm.IDNum = "";
      }
    },
    queryTypeBtn2(index) {
      this.activeTypeIndex2 = index;
      if (index == 1) {
        this.ruleForm1.cerfityNum = "";
      } else if (index == 2) {
        this.ruleForm1.name = "";
        this.ruleForm1.IDNum = "";
      }
    },
    // 成绩查询
    cerfityQuery1() {
      var that = this;
      this.$http
        .post("/api/XOrg/ResultsManager/getStuResultInfo", {
          activeIndex: 2,
          activeTypeIndex: this.activeTypeIndex,
          type: this.ruleForm1.type,
          name: this.ruleForm1.name,
          IDNum: this.ruleForm1.IDNum,
          cerfityNum: this.ruleForm1.cerfityNum,
        })
        .then((rst) => {
          if (rst.code > 0) {
            that.stuInfo = rst.info;
            that.dialogVisible = true;
            that.$nextTick(() => {
              that.getCanvas();
            });
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    handleClick() {},
  },
};
</script>
<style lang='scss'>
.wl-certity-query-wrapper {
  .father {
    /*标签位置设置为相对的*/
    // position: relative;
    text-align: center;
    width: 900px;
    margin: 0 auto;

    // margin-left: -177px;
    .canvas {
      border: 1px solid black;
      // position: absolute;
      // top: 0;
      // left: 110;
      z-index: 1;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center top;
    }
    .canvas_bgp {
      width: 650px;
      height: 550px;
      position: absolute;
      top: 0;
      left: 110;
    }
  }
}
</style>
